import * as React from "react"
import { CrossSellCarousel } from "../../../../components/crossSellCarousel";
import { CrossSell } from "../../../../components/crossSell";
import { useRecommendationsCarouselQuery } from "../../../../hooks/useRecommendationsCarouselQuery";
import { CrossSellListType } from "../../../../definitions/enums";
import {pushToDataLayer} from "../../../../hooks/useCrossSellDataLayerPush";

export const Recommendations = () => {
    const { models, carouselModel } = useRecommendationsCarouselQuery();
 
    // Initialize an empty products array
    let products: Array<{
        title: string;
        sku: string;
        price: number;
        listType: CrossSellListType.UsersWhoBoughtAlsoBought;
    }> = [];

 
    // If there are cross-sells, populate the products array
   if (models || carouselModel) {
        products = models.map((model) => ({
            title: model.product.title,
            sku: model.product.sku,
            price: model.price.unitPrice,
            listType: CrossSellListType.UsersWhoBoughtAlsoBought,
        }));

        // Push to dataLayer regardless of the bundleModel condition
        pushToDataLayer(products);
   }

    // If there are no models or no carousel model, return an empty fragment
    if (!models || !carouselModel) return <></>;

    return (
        <CrossSellCarousel model={carouselModel}>
            {models.map((model, index) => (
                <CrossSell
                    key={index}
                    listType={CrossSellListType.UsersWhoBoughtAlsoBought}
                    model={model}
                    index={index}
                />
            ))}
        </CrossSellCarousel>
    );
};